"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.SubNav = exports.Nav = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Button = _interopRequireDefault(require("../Button"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _theme = require("../utils/theme");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  return {
    navContainer: {
      margin: function margin(props) {
        return props.navMargin && theme.spacing(props.navMargin[0], props.navMargin[1], props.navMargin[2], props.navMargin[3]);
      }
    },
    navButton: {
      color: function color(props) {
        return props.contrastBg ? theme.palette.primary.contrastText : theme.typography.body1.color;
      },
      marginRight: theme.spacing(1),
      borderRadius: 6,
      boxShadow: 'none',
      fontSize: theme.typography.subtitle1.fontSize,
      lineHeight: theme.typography.subtitle1.lineHeight,
      letterSpacing: theme.typography.subtitle1.letterSpacing,
      fontWeight: 500,
      '& > span': {
        fontWeight: 700
      },
      whiteSpace: 'nowrap',
      minWidth: 'max-content'
    },
    activeNavButton: {
      backgroundColor: function backgroundColor(props) {
        return (0, _theme.getActiveBgColorByHeaderType)(theme, props.type);
      }
    },
    expandMoreIcon: {
      height: theme.spacing(3)
    },
    iconOpen: {
      transform: 'rotate(-180deg)',
      transition: 'transform 0.2s ease'
    },
    iconClose: {
      transform: 'rotate(0)',
      transition: 'transform 0.2s ease'
    },
    signupButton: {
      minWidth: 'initial',
      marginRight: theme.spacing(2),
      color: theme.palette.primary.main,
      borderRadius: theme.image && theme.image.borderRadius,
      background: theme.palette.common.white,
      boxShadow: 'none',
      borderWidth: '1px',
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.light,
        borderWidth: '1px'
      }
    },
    loginButton: {
      minWidth: 'initial',
      color: function color(props) {
        return props.contrastBg ? theme.palette.primary.contrastText : theme.palette.primary.main;
      },
      borderColor: theme.palette.common.white,
      borderRadius: theme.image && theme.image.borderRadius,
      borderStyle: 'solid',
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        borderWidth: '1px'
      }
    },
    styledMenu: {
      marginTop: theme.spacing(2),
      '& .MuiPopover-paper': {
        boxShadow: theme.shadows[3],
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6,
        '& ul': {
          paddingTop: 0,
          paddingBottom: 0
        }
      },
      '& li:not(:last-child)': {
        borderBottom: theme.border.light
      }
    },
    styledMenuItem: {
      padding: theme.spacing(3),
      fontSize: 13,
      fontWeight: 600,
      color: function color(props) {
        return (0, _theme.getStyledMenuItemColorByHeaderType)(theme, props.type);
      },
      '&:hover': {
        backgroundColor: theme.palette.background.greyEnterprise
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var SubNav = function SubNav(_ref) {
  var _classNames;

  var type = _ref.type,
      subMenuItem = _ref.subMenuItem,
      subMenuIndex = _ref.subMenuIndex,
      subMenuClassname = _ref.subMenuClassname,
      Link = _ref.Link;
  var classes = useStyles({
    type: type
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showSubMenu = _useState2[0],
      setShowSubMenu = _useState2[1];

  var handleSubMenuOpen = function handleSubMenuOpen(event) {
    setShowSubMenu(event.currentTarget);
  };

  var handleSubMenuClose = function handleSubMenuClose() {
    setShowSubMenu(null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "aria-controls": "menu-submenu",
    key: "nav-item-".concat(subMenuIndex),
    dataQa: subMenuItem.name,
    className: subMenuClassname,
    variant: subMenuItem.variant,
    onClick: handleSubMenuOpen
  }, subMenuItem.buttonName, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    className: (0, _classnames["default"])(classes.expandMoreIcon, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, classes.iconOpen, Boolean(showSubMenu)), (0, _defineProperty2["default"])(_classNames, classes.iconClose, !Boolean(showSubMenu)), _classNames))
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    className: classes.styledMenu,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    anchorEl: showSubMenu,
    id: "menu-submenu",
    open: Boolean(showSubMenu),
    onClose: handleSubMenuClose
  }, subMenuItem.subMenu.map(function (subMenuItem, i) {
    var route = subMenuItem.route,
        textName = subMenuItem.textName;

    var navToSubMenuItemRoute = function navToSubMenuItemRoute(props) {
      return /*#__PURE__*/_react["default"].createElement(Link, (0, _extends2["default"])({}, props, {
        to: route
      }));
    };

    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      className: classes.styledMenuItem,
      key: "nav-item-".concat(subMenuIndex, "-sub-nav-").concat(i),
      dataQa: textName,
      onClick: handleSubMenuClose,
      component: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
        return navToSubMenuItemRoute(props);
      })
    }, textName);
  })));
};

exports.SubNav = SubNav;
var defaultContrastBg = true;
var defaultNavMargin = [0, 8, 0, 8];
var defaultNavJustify = 'flex-end';

var Nav = function Nav(_ref2) {
  var type = _ref2.type,
      items = _ref2.items,
      activeItemName = _ref2.activeItemName,
      highlightActive = _ref2.highlightActive,
      _ref2$Link = _ref2.Link,
      Link = _ref2$Link === void 0 ? _TrackingLink["default"] : _ref2$Link,
      _ref2$contrastBg = _ref2.contrastBg,
      contrastBg = _ref2$contrastBg === void 0 ? defaultContrastBg : _ref2$contrastBg,
      _ref2$navMargin = _ref2.navMargin,
      navMargin = _ref2$navMargin === void 0 ? defaultNavMargin : _ref2$navMargin,
      _ref2$navJustify = _ref2.navJustify,
      navJustify = _ref2$navJustify === void 0 ? defaultNavJustify : _ref2$navJustify;
  var classes = useStyles({
    contrastBg: contrastBg,
    navMargin: navMargin,
    type: type
  });
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    component: "nav",
    justify: navJustify,
    wrap: "nowrap",
    className: classes.navContainer
  }, items.map(function (item, i) {
    var name = item.name,
        buttonName = item.buttonName,
        route = item.route,
        variant = item.variant,
        subMenu = item.subMenu;

    var navToItemRoute = function navToItemRoute(props) {
      return /*#__PURE__*/_react["default"].createElement(Link, (0, _extends2["default"])({}, props, {
        to: route
      }));
    };

    var active = activeItemName === name;
    var classname = (0, _classnames["default"])(classes.navButton, (0, _defineProperty2["default"])({}, classes.activeNavButton, highlightActive && active));

    if (variant === 'contained') {
      classname = classes.signupButton;
    } else if (variant === 'outlined') {
      classname = classes.loginButton;
    }

    if ((0, _isNil["default"])(subMenu)) {
      // a standard button
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        key: "nav-item-".concat(i),
        dataQa: name,
        className: classname,
        variant: variant,
        Component: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
          return navToItemRoute(props);
        })
      }, buttonName);
    } else {
      // dropdown is a Sub Nav Menu
      return /*#__PURE__*/_react["default"].createElement(SubNav, {
        key: "subnav-item-".concat(i),
        type: type,
        subMenuItem: item,
        subMenuIndex: i,
        subMenuClassname: classname,
        Link: Link
      });
    }
  }));
};

exports.Nav = Nav;
var _default = Nav;
exports["default"] = _default;